import { Grid, Paper, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import {
  BLUE_COLOR,
  ORANGE_COLOR,
  RED_COLOR,
} from '../../../../../../constants/ColorsConst';
import { dateformat } from '../../../../../../helpers';
import { useNotification } from '../../../../../../helpers/Notification';
import BotonComponent from '../../../../../dashboard/components/BotonNuevo';
import {
  deletePlanevaTemasAction,
  setActivoPlanevaTemasAction,
} from '../../../planeva_temas/PlanevaTemasAction';
import { setActivoPtemEvaluacionesAction } from '../../../ptem_evaluaciones/PtemEvaluacionesAction';
import { setDetallesPlanEvaluacionAction } from '../../PlanEvaluacionAction';
import EvaluacionesPlanEvaluacion from './EvaluacionesPlanEvaluacion';

const TemasPlanEvaluacion = ({
  isEdit,
  puntos,
  setTotalPuntos,
  setOpenModalForm,
  isDesc = false,
  setTipo,
  planEvaluacion,
}) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const planevaTemasStore = Redux.useSelector((state) => state.planevaTemas);
  const ptemEvaluacionesStore = Redux.useSelector(
    (state) => state.ptemEvaluaciones,
  );

  React.useEffect(() => {
    const fetchData = () => {
      let t = 0;
      planEvaluacion.temas.forEach((tema) => {
        tema.evaluaciones.forEach((eva) => {
          eva.instrumentos.forEach((act) => {
            t = t + Number(act.ponderacion);
          });
        });
      });
      setTotalPuntos(t);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planEvaluacionStore.activo]);

  const botonAddEvaluacion = (planevaTema) =>
    isEdit &&
    puntos !== entidadesStore.ajustes.ponderacion && (
      <BotonComponent
        click={async () => {
          setTipo(1);
          setActivoPlanevaTemasAction(dispatch, planevaTema);
          setActivoPtemEvaluacionesAction(dispatch, null);
          setOpenModalForm(true);
          setDetallesPlanEvaluacionAction(dispatch, null, null);
        }}
        green
        text="AGREGAR EVALUACIÓN"
        addIcon
      />
    );

  return (
    <Grid container spacing={1}>
      {planEvaluacion.temas.map((el) => (
        <Grid key={`tema-${el.id}`} item xs={12} md={12}>
          <Paper
            elevation={4}
            sx={{
              p: 2,
              mt: 1,
              border:
                planevaTemasStore.activo?.id === el.id &&
                !ptemEvaluacionesStore.activo
                  ? `solid 2px ${
                      planEvaluacionStore.detalles.deleteTema
                        ? RED_COLOR
                        : BLUE_COLOR
                    }`
                  : null,
            }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <div>
                <Typography
                  sx={{ fontSize: '8pt', fontWeight: 'bold', mr: 0.5 }}
                >
                  Tema:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 'bold',
                    color: ORANGE_COLOR,
                    mb: el.tema.desc ? 0 : 1,
                  }}
                >
                  {el.tema.titulo}
                </Typography>
              </div>
              <Stack direction="column" alignItems="flex-end">
                <Typography sx={{ fontSize: '10pt' }}>
                  <strong>Desde:</strong>{' '}
                  {dateformat(el.desde, { inverse: true })}
                </Typography>
                <Typography sx={{ fontSize: '10pt' }}>
                  <strong>Hasta:</strong>{' '}
                  {dateformat(el.hasta, { inverse: true })}
                </Typography>
              </Stack>
            </Stack>
            {el.tema.desc && isDesc && <Typography>{el.tema.desc}</Typography>}

            <EvaluacionesPlanEvaluacion
              isEdit={isEdit}
              setTotalPuntos={setTotalPuntos}
              setOpenModalForm={setOpenModalForm}
              isDesc={isDesc}
              setTipo={setTipo}
              planEvaluacion={planEvaluacion}
              tema={el}
            />

            {isEdit && (
              <Stack alignItems="flex-start" sx={{ mt: 1 }}>
                {planEvaluacionStore.detalles.deleteTema &&
                planevaTemasStore.activo?.id === el.id ? (
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography variant="body1" color="initial">
                      {' '}
                      Seguro que desea eliminar este tema
                    </Typography>
                    <BotonComponent
                      click={() => {
                        deletePlanevaTemasAction(
                          { dispatch, notify },
                          planEvaluacion.id,
                          el.id,
                        );
                        setActivoPlanevaTemasAction(dispatch, null);
                        setDetallesPlanEvaluacionAction(
                          dispatch,
                          'deleteActividad',
                          true,
                        );
                        setDetallesPlanEvaluacionAction(dispatch, null, null);
                      }}
                      green
                      text="SI"
                      checkIcon
                    />
                    <BotonComponent
                      click={() => {
                        setActivoPlanevaTemasAction(dispatch, null);
                        setDetallesPlanEvaluacionAction(dispatch, null, null);
                      }}
                      red
                      text="NO"
                      closeIcon
                    />
                  </Stack>
                ) : (
                  <Stack direction="row" spacing={1}>
                    <Stack direction="row" justifyContent="flex-end">
                      {botonAddEvaluacion(el)}
                    </Stack>
                    <BotonComponent
                      click={() => {
                        setActivoPlanevaTemasAction(dispatch, el);
                        setTipo(0);
                        setOpenModalForm(true);
                      }}
                      blue
                      text="EDITAR"
                      editIcon
                    />
                    <BotonComponent
                      click={() => {
                        setActivoPlanevaTemasAction(dispatch, el);
                        setDetallesPlanEvaluacionAction(
                          dispatch,
                          'deleteTema',
                          true,
                        );
                      }}
                      red
                      text="ELIMINAR"
                      deleteIcon
                    />
                  </Stack>
                )}
              </Stack>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default TemasPlanEvaluacion;
